import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FiNewsFeedEditMobileService } from '../edit-mobile/edit-mobile.service';
import { PostModel } from '@fi-shared/models';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { NewsFeedModuleService } from '../news-feed-module.service';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters/access-right-filters.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-news-feed-add-post-mobile',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiNewsFeedAddPostMobileComponent implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(AccessRightFiltersComponent, { static: false }) accessRightFilters: AccessRightFiltersComponent;

    EditorPost: PostModel;

    constructor(
        private newsFeedEditMobileService: FiNewsFeedEditMobileService,
        private loadingService: LoadingService,
        private newsFeedModuleService: NewsFeedModuleService,
        private mobileAppHelperService: FiMobileAppHelperService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    ngOnInit() {
        this.EditorPost = new PostModel(this.fiFormatDateService);
    }

    ngAfterViewInit() {
        this.openEditor();
    }

    openEditor() {
        this.newsFeedEditMobileService
            .openMobilePostEditor(this.EditorPost)
            .afterClosed()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((result) => {
                this.processPostDialogResult(result).then(
                    () => {
                        this.mobileAppHelperService.reloadPriorityFeed();
                        this.mobileAppHelperService.closeIFrame();
                    },
                    () => {
                        this.openEditor();
                    },
                );
            });
    }

    processPostDialogResult(result): Promise<void> {
        if (!result) return Promise.resolve();

        return this.EditorSavePost();
    }

    EditorSavePost() {
        const loading = this.loadingService.startLoading();
        return new Promise<void>((resolve, reject) => {
            this.newsFeedModuleService
                .savePost(this.EditorPost, this.accessRightFilters)
                .then((result) => {
                    loading();
                    if (result) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch(() => {
                    loading();
                    reject();
                });
        });
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
